var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',_vm._g(_vm._b({attrs:{"custom-class":"dialog-component","title":_vm.title},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_vm._t("footer")]},proxy:true}],null,true)},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"body-box"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }